module.exports = __webpack_public_path__ + "img/coach-running.7bf55d33.jpg";